module.exports = __webpack_public_path__ + "static/media/23pic.a1291ce1.jpg";